import {
	useResolveInsightMutation,
	useSubmitInsightHelpfulMutation,
} from "../query";
import type { CopilotInsightListItem } from "../types";
import { InsightHelpfulFeedback } from "./insight-helpful-feedback";
import { InsightMarkResolvedButton } from "./insight-mark-resolved-button";

type InsightExpandedActionsProps = {
	insight: CopilotInsightListItem;
};

/**
 * Orquestra as mutações de "resolvido" e "foi útil" no mesmo lugar para:
 * - página mais enxuta (sem passar callbacks da página);
 * - desabilitar uma ação enquanto a outra está em loading no mesmo insight.
 */
export const InsightExpandedActions = ({
	insight,
}: InsightExpandedActionsProps) => {
	const resolveMutation = useResolveInsightMutation();
	const helpfulMutation = useSubmitInsightHelpfulMutation();

	return (
		<div className="flex flex-col gap-4 pt-4 sm:flex-row sm:flex-wrap sm:items-center sm:justify-between">
			<InsightMarkResolvedButton
				disabled={resolveMutation.isPending || insight.isResolved}
				isPending={resolveMutation.isPending}
				isResolved={insight.isResolved}
				onResolve={() => resolveMutation.mutate(insight.id)}
			/>
			<InsightHelpfulFeedback
				disabled={helpfulMutation.isPending || insight.wasHelpful !== null}
				insightId={insight.id}
				onVote={(insightId, wasHelpful) => {
					helpfulMutation.mutate({ insightId, wasHelpful });
				}}
				selectedWasHelpful={insight.wasHelpful}
			/>
		</div>
	);
};
